import { Injectable } from '@angular/core';
import { DatepickerConfig } from '@com-delta-idp/mnx-capability-flight-shop-ui';

@Injectable({
  providedIn: 'root'
})
export class DateUtilitiesService {
  private _getStartDate = (): Date => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  };

  private _getEndDate = (): Date => {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 331);
    return endDate;
  };

  getDatepickerConfig(): DatepickerConfig {
    return {
      startDate: this._getStartDate(),
      endDate: this._getEndDate()
    };
  }
}
